import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { BookingResponseSchema } from "../response/BookingResponse";

const API_VERSION = 'v3';

interface FilterProps {
    property_id: string;
    base_on: string;
    start_date: string;
    end_date: string;
    room_type_id?: string;
}

interface BookingProps {
    filter?: FilterProps;
}

const useBooking = (params: BookingProps) => {
    return useQuery({
        queryKey: [
            'report',
            'sales',
            JSON.stringify(params.filter) // Pastikan filter bisa digunakan sebagai key
        ],
        queryFn: async () => {
            try {
                const response = await privateApi.get(`/${API_VERSION}/sales-report`, {
                    params: {
                        filter: params.filter
                    }
                });

                // Validasi response
                const validationResult = BookingResponseSchema.safeParse(response.data);
                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid Sales report data format");
                }
                return validationResult.data;
            } catch (error) {
                console.error(`Failed to fetch Sales report`, error);
                throw error;
            }
        },
        enabled: !!params.filter && !!params.filter.property_id && !!params.filter.start_date && !!params.filter.end_date,
        retry: import.meta.env.VITE_MAX_RETRY,
        refetchOnWindowFocus: false
    });
};

export default useBooking;